<template>
  <div id="wrap">
    <common-header/>
    <router-view />
    <common-footer v-if="$route.name !== 'home'"/>
  </div>
</template>

<script>
import CommonHeader from './layout/Header'
import CommonFooter from './layout/Footer'

export default {
  name: 'App',
  components: {
    CommonHeader,
    CommonFooter
  },

}
</script>

<style>
  @import "resource/css/style.css";
</style>
